<template>
  <div
    class="
      tw-size-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-4
    "
  >
    <div
      class="
        tw-rounded-lg
        tw-bg-sf-snow-lighter
        tw-w-[900px]
        tw-h-[400px]
        tw-flex
        tw-flex-col
        tw-gap-4
        tw-justify-center
        tw-items-center
      "
    >
      <img
        class="tw-max-w-[300px]"
        :src="$imagesRequire('empty_states/communication.svg')"
      />
      <div class="tw-font-medium tw-text-lg tw-text-sf-gray">
        <template v-if="anyFilterPresent">
          {{ I18n.t('inbox.empty_state.no_filter_matches_title') }}
        </template>
        <template v-else>
          {{ I18n.t('inbox.empty_state.no_messages_title') }}
        </template>
      </div>
      <div class="tw-font-normal tw-text-sm tw-text-sf-gray">
        <template v-if="anyFilterPresent">
          <a @click="clearFilters">
            {{ I18n.t('inbox.empty_state.no_filter_matches_action') }}
          </a>
          {{ I18n.t('inbox.empty_state.no_filter_matches_text') }}
        </template>
        <template v-else>
          {{ I18n.t('inbox.empty_state.no_messages_text_v2') }}
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useInboxFiltersStore } from '@app/application/communication/screens/inbox/store/inbox-filters'
import { storeToRefs } from 'pinia'

const I18n = useI18n()
const inboxFiltersStore = useInboxFiltersStore()

const { anyFilterPresent } = storeToRefs(inboxFiltersStore)
function clearFilters() {
  inboxFiltersStore.clearFilters()
}
</script>
